
import { Container, Row, Col, Button } from 'react-bootstrap';

export default function Home(){
  

  return (
    <>
            <Container>
              <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
          
              <Row className="align-items-center g-4">
                  <Col xs={12}>
                  <div className="d-flex flex-column align-items-center text-center mb-4" style={{ position: 'relative' }}>
                    <div style={{ position: 'relative', width: '200px', height: '180px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'visible' }}>
                      <svg width="260" height="140" viewBox="0 0 260 140" style={{ position: 'absolute', top: 45, left: '50%', transform: 'translateX(-50%)', zIndex: 2, overflow: 'visible' }} aria-hidden="true">
                        <defs>
                          <path id="nameArc" d="M 0 95 A 130 130 0 0 1 260 95" />
                        </defs>
                        <text fontFamily="'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" fontWeight="700" fontSize="18" letterSpacing="1" fill="#1a3a44">
                          <textPath href="#nameArc" startOffset="50%" textAnchor="middle">
                            Northwest Bible Fellowship
                          </textPath>
                        </text>
                      </svg>
                      <img src="/nbf_logo_ref.svg" alt="Northwest Bible Fellowship"className="home-logo"/>
                    </div>
                  </div>
                  <h1 className="fw-bold text-center" style={{ color: '#c53607f5', fontSize: '3.5rem', marginBottom: '43px' }}>Welcome to Northwest Bible Fellowship!</h1>
                    <p className="welcome-paragraph" style={{ color: '#1a3a44', fontSize: '1.4rem', lineHeight: '1.8', marginBottom: '43px', textIndent: '12px', paddingLeft: '100px', paddingRight: '100px' }}>We are a group of born again believers in the <strong>northwest</strong> side of Pune that strives to follow the <strong>Bible</strong> in all that we do as we <strong>fellowship</strong> together with one heart to glorify the Lord! <br/>
                  Join us for worship, community, and spiritual growth.</p>
                  <div className="text-center">
                  <Button href="#contact" size="lg" style={{ background: 'linear-gradient(180deg, rgba(250, 163, 150, 0.95), #c53607f5)', border: 'none', color: '#fff', fontWeight: '600', fontSize: '1.3rem', padding: '7px 20px' }}>
                    Plan a visit
                  </Button>
                  </div>
                </Col>
              </Row>
              </div>
            </Container>
    </> 
            )

    
            
        
        
}
